module.exports = __webpack_public_path__ + "img/2_71.a3deba22.png";